import * as serviceContext from '../services/serviceContext';
import { BASE_URL_LOGIN, BASE_URL_M_ADMIN } from '../config';
import qs from 'qs';


let options = {};
let headers = new Headers();
const token = sessionStorage.getItem('token');

headers.append('content-type', 'application/json')
headers.append('Authorization', `${token}`);

options.headers = headers;
options.redirect = 'follow';

export async function adminSsoAuth(data){
    try {
        const response = await serviceContext.post(`${BASE_URL_M_ADMIN}madmin/auth`, qs.stringify(data), options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}

export async function validateAuthToken(){
    try {
        const response = await serviceContext.get(`${BASE_URL_M_ADMIN}madmin/auth`, null, options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}